export default (currentAccount) => {
  return currentAccount?.services.map(
    ({
      admin_category,
      account_url,
      display_name,
      project_url: serviceProjectUrl,
      service_access,
      service_category,
      service_domain,
      service_icon,
      service_type,
    }) => ({
      adminCategory: admin_category,
      accountUrl: account_url,
      displayName: display_name,
      projectUrl: serviceProjectUrl,
      serviceAccess: service_access,
      serviceCategory: service_category,
      serviceDomain: service_domain,
      serviceIcon: service_icon,
      serviceType: service_type,
    }),
  );
};
